module.exports = __webpack_public_path__ + "img/wm-bus-repeater-md.6f3cfa17.svg";